import { FETCH_ORDER_AFTER_REFUNDS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_ORDER_AFTER_REFUNDS:
      return action.payload
    default:
      return state
  }
}
